module.exports = __webpack_public_path__ + "img/14.bb0525f7.png";